import React from 'react'
import "./logo.scss"

const Logo = () => {
  return (
    <div className='logo'>
        <h1>EMKEN</h1>
    </div>
  )
}

export default Logo